import { useEffect, useState } from "react";
import { useStyles } from "./styles";
import { Box, Icon, Paper, Grid, Button, Card } from "@material-ui/core";
import { NavLink, useRouteMatch } from "react-router-dom";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { APP_URLS } from "../../../../utilities/constants";
import AppBreadCrumb from "../../../../components/AppBreadCrumb/AppBreadCrumb";
import {
  getSettingRequest,
  saveSettingRequest,
} from "../../OrganisationsApiActions";
import { getUserInfo } from "../../../../utilities/storage";

const Setting = ({ location, history, setting, getSetting, saveSetting }) => {
  const classes = useStyles();
  const match = useRouteMatch();
  const currentUrlPath = match.path.split(":")[0];
  const orgId = getUserInfo()?.Admin?.Organization[0]?.id;

  const [slotDuration, setSlotDuration] = useState(null);
  const [gracePeriod, setGracePeriod] = useState(null);
  const [settingId, setSettingId] = useState(null);

  useEffect(() => {
    ValidatorForm.addValidationRule("isIntegerOrText", (value) => {
      if (value === "") return true;

      const num = Number(value);

      if (!isNaN(num)) {
        if (!Number.isInteger(num)) {
          return false; // Not an integer
        }
      }

      return true;
    });

    ValidatorForm.addValidationRule("minValueIfInteger", (value) => {
      const num = Number(value);
      if (!isNaN(num) && Number.isInteger(num)) {
        return num >= 5;
      }
      return true; // free text allowed
    });

    ValidatorForm.addValidationRule("maxValueIfInteger", (value) => {
      const num = Number(value);
      if (!isNaN(num) && Number.isInteger(num)) {
        return num <= 300;
      }
      return true;
    });

    ValidatorForm.addValidationRule("minGraceDays", (value) => {
      const num = Number(value);
      if (!isNaN(num) && Number.isInteger(num)) {
        return num >= 1;
      }
      return true;
    });

    ValidatorForm.addValidationRule("maxGraceDays", (value) => {
      const num = Number(value);
      if (!isNaN(num) && Number.isInteger(num)) {
        return num <= 99;
      }
      return true;
    });

    return () => {
      ValidatorForm.removeValidationRule("isIntegerOrText");
      ValidatorForm.removeValidationRule("minValueIfInteger");
      ValidatorForm.removeValidationRule("maxValueIfInteger");
      ValidatorForm.removeValidationRule("minGraceDays");
      ValidatorForm.removeValidationRule("maxGraceDays");
    };
  }, []);

  useEffect(() => {
    if (orgId) {
      getSetting(orgId).then((res) => {});
    }
  }, [orgId]);

  useEffect(() => {
    if (setting?.id) {
      setSettingId(setting?.id || null);
      setSlotDuration(setting?.slotTimeDuration || null);
      setGracePeriod(setting?.gracePeriod || null);
    }
  }, [setting]);

  const breadCrumbDataForOrgProfilePage = [
    {
      icon: "settings",
      name: "Setting",
      path: APP_URLS.ORGANIZATIONS_SETTING,
    },
  ];

  /**
   * function to get breadcrumb data for current url
   */
  const getBreadcrumbData = () => {
    return breadCrumbDataForOrgProfilePage;
  };

  /**
   * function to update org
   * @param e: event object on form submission
   */
  const onSave = async (e) => {
    e.preventDefault();

    let payload = {
      slotTimeDuration: slotDuration,
      gracePeriod: gracePeriod,
    };
    const response = await saveSetting(orgId, payload, settingId);
  };

  /**
   * function to handle cancel add or update
   */
  const handleCancel = () => {
    history.goBack();
  };

  return (
    <Box className={classes.outerContainer}>
      <AppBreadCrumb>
        {getBreadcrumbData(currentUrlPath).map((crumb, index) => (
          <Box
            key={index}
            component={NavLink}
            exact
            to={{
              pathname: crumb.path,
              state: {
                orgIdHistory: location.state && location.state.orgIdHistory,
                orgNameHistory: location.state && location.state.orgNameHistory,
              },
            }}
            className={classes.breadcrumbItem}
            activeClassName={classes.activeBreadcrumbItem}
          >
            {crumb.icon && (
              <Icon className={classes.breadcrumpIcon}>{crumb.icon}</Icon>
            )}
            <Box className={classes.breadcrumpLabel}>{crumb.name}</Box>
          </Box>
        ))}
      </AppBreadCrumb>
      <Box mt={2}>
        <ValidatorForm onSubmit={onSave}>
          <Box className={classes.addOragnizationContainer}>
            <Box className={classes.addOragnizationFormContainer}>
              <Box
                component={Paper}
                className={classes.addOragnizationFormInnerContainer}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextValidator
                      label="Slot Duration in Minutes"
                      variant="outlined"
                      fullWidth
                      size="small"
                      type="number"
                      value={slotDuration !== null ? String(slotDuration) : ""}
                      onChange={(e) => setSlotDuration(e.target.value)}
                      validators={[
                        "required",
                        "isIntegerOrText",
                        "minValueIfInteger",
                        "maxValueIfInteger",
                      ]}
                      errorMessages={[
                        "This field is required",
                        "Only integers allowed",
                        "Minimum value is 5",
                        "Maximum value is 300",
                      ]}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextValidator
                      label="Grace Period in days"
                      variant="outlined"
                      fullWidth
                      size="small"
                      type="number"
                      value={gracePeriod !== null ? String(gracePeriod) : ""}
                      onChange={(e) => setGracePeriod(e.target.value)}
                      validators={[
                        "required",
                        "isIntegerOrText",
                        "minGraceDays",
                        "maxGraceDays",
                      ]}
                      errorMessages={[
                        "This field is required",
                        "Only integers allowed",
                        "Minimum value is 1 day",
                        "Maximum value is 99 days",
                      ]}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>

          <Box className={classes.footerContainer}>
            <Box
              component={Card}
              raised
              className={classes.footerContainerInner}
            >
              <Box>
                <Button
                  variant="outlined"
                  color="primary"
                  disableElevation={true}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  disableElevation={true}
                  type="submit"
                  className={classes.saveButton}
                >
                  Save
                </Button>
              </Box>
            </Box>
          </Box>
        </ValidatorForm>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    setting: state.organisations.setting,
  };
};

const mapDispatchToProp = (dispatch) => {
  return {
    getSetting: (orgId) => {
      return dispatch(getSettingRequest(orgId)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    saveSetting: (id, data, settingId = "") => {
      return dispatch(saveSettingRequest(id, data, settingId)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProp)(Setting);
